import React from 'react';
import './ConsultingInquiry.css';

const ConsultingInquiry = () => {
  const features = [
    {
      title: "Professional Consulting",
      description: "We provide expert guidance and strategic advice to help you navigate complex challenges and achieve your business goals."
    },
    {
      title: "Valuable Ideas",
      description: "Our team generates innovative and actionable ideas tailored to your needs, driving growth and setting you apart from the competition."
    },
    {
      title: "Excellent Timing",
      description: "We pride ourselves on timely execution and delivering solutions exactly when you need them, ensuring your projects stay on schedule."
    },
    {
      title: "Budget Friendly",
      description: "Our services are designed to provide maximum value, offering high-quality solutions that align with your financial resources."
    }
  ];

  return (
    <section className="consulting-inquiry-section">
      <div className="container">
        <div className="inquiry-header">
          <h2 className="inquiry-title">Looking for Accounting | Consulting?</h2>
          <a href="/contact-us" className="inquiry-button">CONTACT US TODAY</a>
        </div>
        <div className="inquiry-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="inquiry-feature-card">
              <h3 className="inquiry-feature-title">{feature.title}</h3>
              <p className="inquiry-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsultingInquiry;
